import {
  DPA_ID_MISSING,
  INVALID_PARAMETER,
  SRCI_ID_MISSING,
  SRCI_TXN_ID_MISSING
} from '../constants/api-error-enums';
import InitModel from '../schemas/init';
import constructValidationMessage from './construct-validation-message';

const validateInitData = data => {
  const { error } = InitModel.validate(data, { abortEarly: false });
  const srcInitiatorIdError = error && error.details.some(o => o.context.key === 'srcInitiatorId');
  const srcDpaIdError =
    (error && error.details.some(o => o.context.peers && o.context.peers.includes('dpaData'))) ||
    !(data.srciDpaId || (data.dpaData && data.dpaData.srcDpaId));
  const srcTXNIdError = error && error.details.some(o => o.context.key === 'srciTransactionId');

  let reason;
  if (srcDpaIdError) {
    reason = DPA_ID_MISSING;
  } else if (srcInitiatorIdError) {
    reason = SRCI_ID_MISSING;
  } else if (srcTXNIdError) {
    reason = SRCI_TXN_ID_MISSING;
  } else if (error) {
    reason = INVALID_PARAMETER;
  }

  return constructValidationMessage(error, 'init()', reason);
};

export default validateInitData;
